import styled from 'styled-components';
import is from 'typescript-styled-is';

export interface FlexProps {
  wrap?: string;
  spaceBetween?: boolean;
  justifyContentCenter?: boolean;
  alignItemsCenter?: boolean;
  justifyContent?: string;
  flexDirection?: string;
  alignItems?: string;
  margin?: string;
  noShrink?: boolean;
  borderRadius?: string;
  centered?: boolean;
  inline?: boolean;
  textAlignStart?: boolean;
  flexGrow?: boolean;
  hiddenOverflow?: boolean;
}

// TODO - move it to common
export const Flex = styled.div<FlexProps>`
  display: flex;
  ${is('inline')`
    display: inline-flex;
  `};

  ${is('margin')`
    margin: ${(props) => props.margin}
  `};

  ${is('flexDirection')`
    flex-direction: ${(props) => props.flexDirection};
  `};

  ${is('alignItems')`
    align-items: ${(props) => props.alignItems};
  `};

  ${is('wrap')`
    flex-wrap: wrap;
  `};

  ${is('spaceBetween')`
    justify-content: space-between;
  `};

  ${is('justifyContentCenter')`
    justify-content: center;
  `};

  ${is('alignItemsCenter')`
    align-items: center;
  `};

  ${is('justifyContent')`
    justify-content: ${(props) => props.justifyContent};
  `};

  ${is('centered')`
    justify-content: center;
    align-items: center;
  `};

  ${is('noShrink')`
    flex-shrink: 0;
  `};

  ${is('borderRadius')`
    border-radius: ${(props) => props.borderRadius};
  `};

  ${is('textAlignStart')`
    text-align: start;
  `}

  ${is('flexGrow')`
    flex-grow: 1;
  `}

  ${is('hiddenOverflow')`
    overflow: hidden;
  `}
`;
